module.exports = __webpack_public_path__ + "static/Jones-next-to-border-patrol-vehicle-2b612705d9d49de1cfa3a90420632fe9.jpg";